import { Show } from "solid-js";
import { describeError } from "./describeError.ts";

export { describeError };

export function ErrorBanner(props: { error: unknown | null }) {
  return (
    <Show when={props.error !== null && props.error !== undefined}>
      <div class="error-banner" role="alert">
        {describeError(props.error)}
      </div>
    </Show>
  );
}
